
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"#55A3FF","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.484 6.047h-.656V3.516A3.52 3.52 0 0016.313 0H7.688a3.52 3.52 0 00-3.516 3.516v2.53h-.656A3.52 3.52 0 000 9.563v5.626a3.52 3.52 0 003.516 3.515h.656v3.188c0 1.163.946 2.109 2.11 2.109h11.437c1.163 0 2.11-.946 2.11-2.11v-3.187h.655A3.52 3.52 0 0024 15.188V9.561a3.52 3.52 0 00-3.516-3.515zM5.578 3.516c0-1.163.946-2.11 2.11-2.11h8.625c1.163 0 2.109.947 2.109 2.11v2.53H5.578v-2.53zM18.422 21.89a.704.704 0 01-.703.703H6.28a.704.704 0 01-.703-.703v-6.938h12.844v6.938zm4.172-6.703c0 1.163-.947 2.109-2.11 2.109h-.656v-2.344h.422a.703.703 0 000-1.406H3.75a.703.703 0 000 1.406h.422v2.344h-.656a2.112 2.112 0 01-2.11-2.11V9.564c0-1.164.947-2.11 2.11-2.11h16.968c1.163 0 2.11.946 2.11 2.11v5.624z","fill":"inherit"}}),_c('path',{attrs:{"d":"M13.875 16.547h-3.75a.703.703 0 000 1.406h3.75a.703.703 0 000-1.406zM13.875 19.547h-3.75a.703.703 0 000 1.406h3.75a.703.703 0 000-1.406zM6 9.047H3.75a.703.703 0 000 1.406H6a.703.703 0 000-1.406z","fill":"inherit"}})])
          )
        }
      }
    